/**
 * Build a DRF querystring for filters, ordering, and pagination
 * @param {Object} filters - key/value filters
 * @param {Object} options - { page, pageSize, sort }
 * @param {Array} columns - column definitions for type-based handling
 */

export function qs(filters = {}, options = {}, columns = []) {
    const params = Object.entries(filters)
        .filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        .map(([k, v]) => {
            const column = columns.find(c => c.key === k)
            if (column?.type === 'text' || k === 'search') {
                // generic icontains filter
                return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
            }
            return `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
        })

    // DRF-style ordering
    if (options.sort?.field) {
        const prefix = options.sort.direction === 'asc' ? '' : '-'
        params.push(`ordering=${prefix}${encodeURIComponent(options.sort.field)}`)
    }

    // DRF pagination
    if (options.page != null) params.push(`page=${options.page}`)
    if (options.pageSize != null) params.push(`page_size=${options.pageSize}`)

    return params.join('&')
}